export enum AbTestKeys {
	Test = 'test',
	PromoBanner = 'promo_countdown',
	Edgeworkers = 'plp_best_sellers',
	ShowDiscount = 'show_discount_test_abc',
	modalNoStockStartCheckout = 'modal_no_stock_start_checkout',
	shoppingcartTransactionalProductCard = 'shoppingcart_transactional_product_card',
	pdp_shop_the_look = 'pdp_shop_the_look',
}
